
import axios from "axios";

const API_BASE_URL = window.location.hostname === "localhost"
    ? "http://localhost:5000"  // 🔹 Backend local en desarrollo
    : "https://mi-api-695949786110.us-central1.run.app"; // 🔹 Cloud Run en producción

console.log("📡 API Base URL:", API_BASE_URL); // ✅ Esto imprimirá la URL en la consola

// ✅ Crear una instancia de Axios con configuración global
export const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000, // Tiempo máximo de espera de 30s (margen para cold start de Cloud Run)
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // Para evitar problemas de CORS
    },
});

// ✅ Función genérica para obtener datos desde la API con manejo de errores
const fetchData = async (endpoint, params = {}) => {
    try {
        console.log(`📡 Fetching from: ${API_BASE_URL}${endpoint}`);
        const response = await apiClient.get(endpoint, { params });
        console.log("✅ API Response:", response.data);
        return response.data;
    } catch (error) {
        console.error(`❌ Error fetching data from ${endpoint}:`, error.response?.data || error.message);
        return [];
    }
};

// ✅ Función para iniciar sesión
export const loginUser = async (mail_u, password_u) => {
    try {
        console.log("📡 Intentando login...");
        const response = await apiClient.post("/login", { mail_u, password_u });
        console.log("✅ Respuesta del login:", response.data);
        return response.data;
    } catch (error) {
        console.error("❌ Error en login:", error.response?.data || error.message);
        throw error;
    }
};


//info para 1.home.js
// ✅ Obtener información de la empresa
export const getCompanyInfo = async (id_c) => {
    try {
        const response = await apiClient.get(`/company/${id_c}`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching company info:", error.response?.data || error.message);
        return null;
    }
};
/*
// ✅ Obtener nombre de la empresa
export const getCompanyName = async (id_c) => {
    try {
        const response = await apiClient.get(`/company/${id_c}`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching company info:", error.response?.data || error.message);
        return null;
    }
};
*/

// ✅ Obtener el conteo de usuarios
export const getUserCount = async (id_c) => {
    try {
        const response = await apiClient.get(`/company/${id_c}/users/count`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching user count:", error.response?.data || error.message);
        return null;
    }
};



// Obtener Nombre de usuario
// 🔍 Obtener el nombre del usuario por ID y compañía


//v2
export const getUserName = async (id_c, id_u) => {
    try {
        const response = await apiClient.get(`/company/${id_c}/user/${id_u}`); // ✅ CORRECTO
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching user name:", error.response?.data || error.message);
        return null;
    }
};


//Obtener Rol Usuario
export const getUserRol = async (id_c, id_u) => {
    try {
        const response = await apiClient.get(`/company/${id_c}/user/${id_u}`); // ✅ CORRECTO
        return response.data; 
    } catch (error) {
        console.error("❌ Error fetching user name:", error.response?.data || error.message);
        return null;
    }
};





// ✅ Obtener la lista de máquinas y conteo de activas/inactivas
export const getMachines = async (id_c) => {
    try {
        const response = await apiClient.get(`/company/${id_c}/machines`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching machines:", error.response?.data || error.message);
        return null;
    }
};




//----------------- PRODUCTS --------------------
// Obtener lista de productos


export const getProducts = async (id_c) => {
    try {
        const response = await apiClient.get(`/company/${id_c}/products`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching products:", error.response?.data || error.message);
        return null;
    }
};


//obtener lista de modelos de Productos especificos de prod_list

export const getModelsByProduct = async (id_c, id_prod) => {
  try {
    const response = await apiClient.get(`/models/by-product/${id_c}/${id_prod}`);
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener modelos por producto:", error);
    return { models: [] };
  }
};


// ✅ Obtener un producto por compañía + id_prod
export const getProduct = async (id_c, id_prod) => {
  try {
    const res = await apiClient.get(`/company/${id_c}/products/${id_prod}`);
    return res.data;
  } catch (error) {
    console.error("❌ Error getProduct:", error.response?.data || error.message);
    return null;
  }
};

// ✅ Actualizar producto
export const updateProduct = async (id_c, id_prod, productData) => {
  try {
    const res = await apiClient.put(`/company/${id_c}/products/${id_prod}`, productData);
    return res.data;
  } catch (error) {
    console.error("❌ Error updateProduct:", error.response?.data || error.message);
    return null;
  }
};

// ✅ Eliminar producto
export const deleteProduct = async (id_c, id_prod) => {
  try {
    const res = await apiClient.delete(`/company/${id_c}/products/${id_prod}`);
    return res.data;
  } catch (error) {
    console.error("❌ Error deleteProduct:", error.response?.data || error.message);
    return null;
  }
};


//Obtener producto asociado a una maquina
//V1

export const getProductsByMachine = async (id_c, cod_maq) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/products/by_machine/${encodeURIComponent(cod_maq)}`);
    return data; // { products, total }
  } catch (error) {
    console.error("❌ Error fetching products by machine:", error.response?.data || error.message);
    return { products: [], total: 0 };
  }
};








//  ----------BATCHES TEMP-------------------
// ===================== BATCHES TEMP (dos pasos) =====================
export const getBatchesTemp = async (id_c) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/batches-temp`);
    return data; // { batches, total }
  } catch (e) {
    console.error("❌ Error fetching batches-temp:", e.response?.data || e.message);
    return { batches: [], total: 0 };
  }
};

export const getBatchTemp = async (id_c, id) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/batches-temp/${id}`);
    return data; // { batch }
  } catch (e) {
    console.error("❌ Error fetching batch-temp:", e.response?.data || e.message);
    throw e;
  }
};

export const createBatchTemp = async (id_c, payload) => {
  try {
    const { data } = await apiClient.post(`/company/${id_c}/batches-temp`, payload);
    return data;
  } catch (e) {
    console.error("❌ Error creating batch-temp:", e.response?.data || e.message);
    throw e;
  }
};

export const updateBatchTemp = async (id_c, id, payload) => {
  try {
    const { data } = await apiClient.put(`/company/${id_c}/batches-temp/${id}`, payload);
    return data;
  } catch (e) {
    console.error("❌ Error updating batch-temp:", e.response?.data || e.message);
    throw e;
  }
};

export const deleteBatchTemp = async (id_c, id) => {
  try {
    const { data } = await apiClient.delete(`/company/${id_c}/batches-temp/${id}`);
    return data;
  } catch (e) {
    console.error("❌ Error deleting batch-temp:", e.response?.data || e.message);
    throw e;
  }
};

export const finalizeBatchTemp = async (id_c, id) => {
  try {
    const { data } = await apiClient.post(`/company/${id_c}/batches-temp/${id}/finalize`);
    return data; // { message }
  } catch (e) {
    console.error("❌ Error finalizing batch-temp:", e.response?.data || e.message);
    throw e;
  }
};







//-------------BATCHES ------------------------------------------------
// Obtener lista de Batches


export const getBatches = async (id_c) => {
    try {
        const response = await apiClient.get(`/company/${id_c}/batches`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching batches:", error.response?.data || error.message);
        return null;
    }
};


// Obtener lista de batches 2  Consolidado


export const getBatches2 = async (id_c) => {
    try {
        const response = await apiClient.get(`/company/${id_c}/batches/consolidado`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching batches:", error.response?.data || error.message);
        return null;
    }
};

//borrar registro de batches_consolidado
export const deleteBatchConsolidado = async (id) => {
  return await apiClient.delete(`/batches_consolidado/${id}`);
};




// Obtener lista de batches Report  Consolidado -----------------------------

export const getBatchesRep = async (id_c) => {
    try {
        const response = await apiClient.get(`/company/${id_c}/batches/consolidado`);
        return response.data;
    } catch (error) {
        console.error("❌ Error fetching batches:", error.response?.data || error.message);
        return null;
    }
};

// Obtener un batch_consolidado por id
export const getBatchConsolidadoById = async (id_c, id) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/batches_consolidado/${id}`);
    return data; // { batch }
  } catch (error) {
    console.error("❌ Error fetching batch consolidado:", error.response?.data || error.message);
    throw error;
  }
};

// Actualizar un batch_consolidado
export const updateBatchConsolidado = async (id_c, id, payload) => {
  try {
    const { data } = await apiClient.put(`/company/${id_c}/batches_consolidado/${id}`, payload);
    return data; // { message, updatedId }
  } catch (error) {
    console.error("❌ Error updating batch consolidado:", error.response?.data || error.message);
    throw error;
  }
};














//--------------------------------------------------------------------------------------





//obtener lista de máquinas asocuiadas a un producto especifico

export const getMachinesByProduct = async (id_c, id_prod) => {
  try {
    const response = await apiClient.get(`/machines/by-product/${id_c}/${id_prod}`);
    return response.data;
  } catch (error) {
    console.error("❌ Error al obtener máquinas por producto:", error);
    return { machines: [] };
  }
};






//obtener datos para getbatches3
export const getBatches3 = async (id_c, id_batch, id_prod) => {
  try {
    const response = await apiClient.get(`/company/${id_c}/batch/${id_batch}/product/${id_prod}`);
    return response.data;
  } catch (error) {
    console.error("❌ Error al traer batch filtrado:", error);
    return [];
  }
};




// SHIFTS

// ===================== SHIFTS (Turnos) =====================


export const createShift = async (payload) => {
  try {
    const { data } = await apiClient.post(`/turnos`, payload);
    return data; // { message, total_hr_shift }
  } catch (error) {
    console.error("❌ Error creando turno:", error.response?.data || error.message);
    throw error;
  }
};

/** Obtener lista de turnos de la empresa */
export const getShifts = async (id_c) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/shifts`);
    return data; // { shifts, total }
  } catch (error) {
    console.error("❌ Error fetching shifts:", error.response?.data || error.message);
    return null;
  }
};

/** Obtener un turno puntual */
export const getShift = async (id_c, id_shift) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/shifts/${id_shift}`);
    return data; // { id_c, id_shift, time_begin, time_end, total_hr_shift, observations }
  } catch (error) {
    console.error("❌ Error fetching shift:", error.response?.data || error.message);
    return null;
  }
};

/** Actualizar un turno (recalcula total_hr_shift en backend) */
export const updateShift = async (id_c, id_shift, payload) => {
  try {
    const { data } = await apiClient.put(`/company/${id_c}/shifts/${id_shift}`, payload);
    return data; // { message, total_hr_shift }
  } catch (error) {
    console.error("❌ Error updating shift:", error.response?.data || error.message);
    throw error;
  }
};

/** Borrar un turno */
export const deleteShift = async (id_c, id_shift) => {
  try {
    const { data } = await apiClient.delete(`/company/${id_c}/shifts/${id_shift}`);
    return data; // { message }
  } catch (error) {
    console.error("❌ Error deleting shift:", error.response?.data || error.message);
    throw error;
  }
};




// ACTIVITY TYPES
// ===================== ACTIVITY TYPES =====================

// Lista
export const getActTypes = async (id_c) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/types`);
    return data; // { types, total }
  } catch (error) {
    console.error("❌ Error fetching types:", error.response?.data || error.message);
    return null;
  }
};

// Crear
export const createActType = async (id_c, payload) => {
  try {
    const { data } = await apiClient.post(`/company/${id_c}/types`, payload);
    return data; // { message, insertId }
  } catch (error) {
    console.error("❌ Error creando activity type:", error.response?.data || error.message);
    throw error;
  }
};

// Obtener uno
export const getActType = async (id_c, id_activity) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/types/${id_activity}`);
    return data; // { id_c, id_activity, oper_active, observations }
  } catch (error) {
    console.error("❌ Error fetching activity type:", error.response?.data || error.message);
    return null;
  }
};

// Actualizar
export const updateActType = async (id_c, id_activity, payload) => {
  try {
    const { data } = await apiClient.put(`/company/${id_c}/types/${id_activity}`, payload);
    return data; // { message }
  } catch (error) {
    console.error("❌ Error updating activity type:", error.response?.data || error.message);
    throw error;
  }
};

// Borrar
export const deleteActType = async (id_c, id_activity) => {
  try {
    const { data } = await apiClient.delete(`/company/${id_c}/types/${id_activity}`);
    return data; // { message }
  } catch (error) {
    console.error("❌ Error deleting activity type:", error.response?.data || error.message);
    throw error;
  }
};



// ACTIVITY LIST REPORT
export const getActList = async (id_c) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/activity_list`);
    return data; // { activities, total }
  } catch (error) {
    console.error("❌ Error fetching activities:", error.response?.data || error.message);
    return null;
  }
};

// Obtener una actividad por ID (útil para editar)
export const getActivity = async (id_c, id) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/activity/${id}`);
    return data; // { activity: {...} }
  } catch (error) {
    console.error("❌ Error fetching activity:", error.response?.data || error.message);
    return null;
  }
};


// Obtener actividad por ID (nuevo método específico)
export const getActivityById = async (id_c, id) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/activity/${id}`);
    return data; // { activity }
  } catch (error) {
    console.error("❌ Error fetching activity:", error.response?.data || error.message);
    throw error;
  }
};

// Actualizar actividad
export const updateActivity = async (id_c, id, payload) => {
  try {
    const { data } = await apiClient.put(`/company/${id_c}/activity/${id}`, payload);
    return data; // { message, updatedId }
  } catch (error) {
    console.error("❌ Error updating activity:", error.response?.data || error.message);
    throw error;
  }
};

// Borrar actividad
export const deleteActivity = async (id_c, id) => {
  try {
    const { data } = await apiClient.delete(`/company/${id_c}/activity/${id}`);
    return data; // { message, deletedId }
  } catch (error) {
    console.error("❌ Error deleting activity:", error.response?.data || error.message);
    throw error;
  }
};

// Crear actividad
export const createActivity = async (id_c, payload) => {
  try {
    const { data } = await apiClient.post(`/company/${id_c}/activity`, payload);
    return data; // { message, insertedId }
  } catch (error) {
    console.error("❌ Error creating activity:", error.response?.data || error.message);
    throw error;
  }
};

// Traer tipos de actividad
export const getActivityTypes = async (id_c) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/types`);
    return data; // { types, total }
  } catch (error) {
    console.error("❌ Error fetching activity types:", error.response?.data || error.message);
    return { types: [], total: 0 };
  }
};


//--------------------------- OPERATORS LIST------------------------------------------------------------------

// Lista de operadores
export const getOperatorsL = async (id_c) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/operator`);
    return data; // { types, total }
  } catch (error) {
    console.error("❌ Error fetching operators:", error.response?.data || error.message);
    return null;
  }
};

// Crear
export const createOperator = async (id_c, payload) => {
  try {
    const { data } = await apiClient.post(`/company/${id_c}/operator`, payload);
    return data; // { message, insertId }
  } catch (error) {
    console.error("❌ Error creando operator:", error.response?.data || error.message);
    throw error;
  }
};

// Obtener uno
export const getOperator = async (id_c, id_operator) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/operator/${id_operator}`);
    return data; // { id_c, id_operator, name_oper }
  } catch (error) {
    console.error("❌ Error fetching operator:", error.response?.data || error.message);
    return null;
  }
};
//Actualizar Operador
export const updateOperator = async (id_c, id_operator, payload) => {
  try {
    const { data } = await apiClient.put(`/company/${id_c}/operator/${id_operator}`, payload);
    return data; // { message: "Updated" }
  } catch (error) {
    console.error("❌ Error updating operator:", error.response?.data || error.message);
    throw error;
  }

};
// Borrar
export const deleteOperator = async (id_c, id_operator) => {
  try {
    const { data } = await apiClient.delete(`/company/${id_c}/operator/${id_operator}`);
    return data;
  } catch (error) {
    console.error("❌ Error deleting operator:", error.response?.data || error.message);
    throw error;
  }
};




//// ===================== SHIFT REPORT =====================
// Llama a: GET /company/:id_c/shift-report?date=YYYY-MM-DD&cod_maq=XXX&id_shift=YYY
// Respuesta esperada: { shift: {...}, items: [...] }
export const getShiftReport = async (id_c, { date, cod_maq, id_shift }) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/shift-report`, {
      params: { date, cod_maq, id_shift }
    });
    return data; // { shift, items }
  } catch (error) {
    console.error("❌ Error fetching shift report:", error.response?.data || error.message);
    // Mantén consistencia con tu estilo: lanzar error cuando es crítico
    throw error;
  }
};





//   PARA DASHBOARD INICIAL ------------------------------------------------------------------------------
export const getDashboardKpis = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(`/company/${id_c}/dashboard/kpis?` + params.toString());
  return data;
};

//operaciones en dashboard inicial
//v1
/*
export const getOpsCount = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(`/company/${id_c}/dashboard/ops-count?` + params.toString());
  return data; // { total_act }
};
*/
//v2
export const getOpsCount = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(`/company/${id_c}/dashboard/ops-count?` + params.toString());
  return data; // { total_act }
};

// export { apiClient } ya definido

export const getDashboardOperations = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(`/company/${id_c}/dashboard/operations?` + params.toString());
  return data;
};


// LOTES en dashboard (conteo por rango de días y máquinas)
export const getLotsCount = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(`/company/${id_c}/dashboard/lots-count?` + params.toString());
  return data; // { days, machine_codes, total_lots }
};


// HORAS NO ACTIVAS en dashboard (sum de activity_report con oper_active=0)
export const getInactiveHours = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(`/company/${id_c}/dashboard/inactive-hours?` + params.toString());
  return data; // { days, machine_codes, total_inactive_hours }
};

// HORAS REPORTADAS (lotes) en dashboard (suma de duraciones de batches_consolidado)
export const getReportedHours = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(
    `/company/${id_c}/dashboard/reported-hours?` + params.toString()
  );
  return data; // { days, machine_codes, total_reported_hours }
};


// Productos conformes / no conformes en dashboard (suma de cant_pt_ok y cant_pt_nc)
export const getProductsSummary = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(
    `/company/${id_c}/dashboard/products-summary?` + params.toString()
  );
  return data; // { days, machine_codes, total_ok, total_nc }
};

// Obtener máquinas de una compañía
export const getMachinesByCompany = async (id_c) => {
  const { data } = await apiClient.get(`/company/${id_c}/machines`);
  // El backend responde: { machines, activeCount, inactiveCount }
  return data;
};


// 🔹 Operaciones estándar / hora y reales / hora en dashboard
// GET /company/:id_c/dashboard/ops-per-hour
export const getOpsPerHour = async ({ id_c, days = 30, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("days", String(days));
  if (machineCodes.length) {
    params.set("machine_codes", machineCodes.join(","));
  }

  const { data } = await apiClient.get(
    `/company/${id_c}/dashboard/ops-per-hour?` + params.toString()
  );
  return data; // { standard_ops_per_hour, real_ops_per_hour, ... }
};




//---------------------------------------------------------------------------------


//OEE REPORTE  OeeRep1

// ===================== OEE REP1 (RANGO DE FECHAS INCLUSIVO) =====================

// Operaciones (SUM act) por rango
export const getOpsCountRep1 = async ({ id_c, dateFrom, dateTo, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("date_from", String(dateFrom)); // YYYY-MM-DD
  params.set("date_to", String(dateTo));     // YYYY-MM-DD
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));

  const { data } = await apiClient.get(
    `/company/${id_c}/oee-rep1/ops-count?` + params.toString()
  );
  return data; // { total_act, date_from, date_to, machine_codes }
};

// Lotes (COUNT batches_consolidado) por rango
export const getLotsCountRep1 = async ({ id_c, dateFrom, dateTo, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("date_from", String(dateFrom));
  params.set("date_to", String(dateTo));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));

  const { data } = await apiClient.get(
    `/company/${id_c}/oee-rep1/lots-count?` + params.toString()
  );
  return data; // { total_lots, ... }
};

// Horas no activas (SUM activity_report con oper_active=0) por rango
export const getInactiveHoursRep1 = async ({ id_c, dateFrom, dateTo, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("date_from", String(dateFrom));
  params.set("date_to", String(dateTo));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));

  const { data } = await apiClient.get(
    `/company/${id_c}/oee-rep1/inactive-hours?` + params.toString()
  );
  return data; // { total_inactive_hours, ... }
};

// Horas reportadas (SUM total_hr_batch en batches_consolidado) por rango
export const getReportedHoursRep1 = async ({ id_c, dateFrom, dateTo, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("date_from", String(dateFrom));
  params.set("date_to", String(dateTo));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));

  const { data } = await apiClient.get(
    `/company/${id_c}/oee-rep1/reported-hours?` + params.toString()
  );
  return data; // { total_reported_hours, ... }
};

// Productos OK/NC (SUM cant_pt_ok / cant_pt_nc) por rango
export const getProductsSummaryRep1 = async ({ id_c, dateFrom, dateTo, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("date_from", String(dateFrom));
  params.set("date_to", String(dateTo));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));

  const { data } = await apiClient.get(
    `/company/${id_c}/oee-rep1/products-summary?` + params.toString()
  );
  return data; // { total_ok, total_nc, ... }
};

// Operaciones estándar/h y reales/h por rango
export const getOpsPerHourRep1 = async ({ id_c, dateFrom, dateTo, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("date_from", String(dateFrom));
  params.set("date_to", String(dateTo));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));

  const { data } = await apiClient.get(
    `/company/${id_c}/oee-rep1/ops-per-hour?` + params.toString()
  );
  return data; // { standard_ops_per_hour, real_ops_per_hour, total_hours, ... }
};





// Desglose de horas no activas por tipo de actividad
export const getActivityTypeBreakdown = async ({ id_c, dateFrom, dateTo, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("date_from", String(dateFrom));
  params.set("date_to", String(dateTo));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(
    `/company/${id_c}/activity-type-report/breakdown?` + params.toString()
  );
  return data; // { by_type: [{id_activity, label, hours}] }
};

export const getActivityTypeTimeSeries = async ({ id_c, dateFrom, dateTo, machineCodes = [] }) => {
  const params = new URLSearchParams();
  params.set("date_from", String(dateFrom));
  params.set("date_to", String(dateTo));
  if (machineCodes.length) params.set("machine_codes", machineCodes.join(","));
  const { data } = await apiClient.get(
    `/company/${id_c}/activity-type-report/timeseries?` + params.toString()
  );
  return data; // { series: [{period, reported_hours, inactive_hours}] }
};

//------------------------------------------------------------------------------------//

//SCREEN X 1


// ===================== BATCH TEMP ACTIVO (POR MÁQUINA) =====================
export const getActiveBatchTempByMachine = async ({ id_c, cod_maq }) => {
  try {
    const { data } = await apiClient.get(
      `/company/${id_c}/batches-temp/active/${encodeURIComponent(cod_maq)}`
    );
    return data; // { ok, reason, count, batch?, batches? }
  } catch (e) {
    console.error("❌ Error fetching active batch-temp by machine:", e.response?.data || e.message);
    return { ok: false, reason: "request_error", message: e.message };
  }
};

//--------------
// ===================== PROD LIST - POR MÁQUINA + REFERENCIA =====================
export const getProdByMachineAndRef = async ({ id_c, cod_maq, id_prod }) => {
  try {
    const { data } = await apiClient.get(
      `/company/${id_c}/prod-list/by-machine/${encodeURIComponent(cod_maq)}/${encodeURIComponent(id_prod)}`
    );
    return data; // { ok, product? }
  } catch (e) {
    console.error("❌ Error fetching prod-list by machine+ref:", e.response?.data || e.message);
    return { ok: false, reason: "request_error", message: e.message };
  }
};


//-------------------
// ===================== REAL TIME (Screen1) =====================
export const getRtOperationsCount = async ({
  id_c,
  cod_maq,
  start_date,
  start_time,
  end_date,
  end_time,
}) => {
  try {
    const { data } = await apiClient.get(`/company/${id_c}/rt/operations-count`, {
      params: { cod_maq, start_date, start_time, end_date, end_time },
    });
    return data; // { ok, total_act, range }
  } catch (e) {
    console.error("❌ Error fetching rt operations-count:", e.response?.data || e.message);
    return { ok: false, total_act: 0, message: e.response?.data?.message || e.message };
  }
};